import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import OnlineClasses from '../views/OnlineClasses.vue'
import MindMaps from '../views/MindMaps.vue'
import Customer from '../views/customer/Customer.vue'
import Calculations from '../views/customer/calculations/Calculations.vue'
import CustomerCalculationList from '../views/customer/calculations/CalculationList.vue'
import CustomerRules from '../views/customer/Rules.vue'
import GenialReport from '../views/customer/GenialReport.vue'
import FutureRules from '../views/customer/FutureRules.vue'
import RulesNotApplicable from '../views/customer/RulesNotApplicable.vue'
import CustomerWorkRecords from '../views/customer/work-records/WorkRecords.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import GenialGuardRegister from '../views/GenialGuardRegister.vue'
import ChallengeCheckout from '../views/ChallengeCheckout.vue'
import Plans from '../views/Plans.vue'
import GenialGuardPlans from '../views/GenialGuardPlans.vue'
import Users from '../views/Users.vue'
import UserEdit from '../views/user/UserEdit.vue'
import ListUsers from '../views/user/List.vue'
// import NewCalculation from '../views/calculations/New.vue'
// import ViewCalculation from '../views/calculations/View.vue'
// import EditCalculation from '../views/calculations/Edit.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Management from '../views/Management.vue'
import Accounts from '../views/management/Accounts.vue'
import Indexes from '../views/management/Indexes.vue'
import RetirementFactors from '../views/management/RetirementFactors.vue'
import ChatMonitor from '../views/management/ChatMonitor.vue'
import ConversationDetail from '../views/management/ConversationDetail.vue'
import AgentConfigurator from '../views/management/AgentConfigurator.vue'
import BancadaGenIA from '../views/BancadaGenIA.vue'

Vue.use(VueRouter)

import isAuthenticated from './policies/isAuthenticated'
import isNotAuthenticated from './policies/isNotAuthenticated'
import isManagement from './policies/isManagement'
import hasFeature from './policies/hasFeature'

// Helper que encadeia 2 guards do Vue Router. Permite combinar
// isAuthenticated com hasFeature sem precisar reescrever a logica
// de cada guard.
const chainGuards = (...guards) => (to, from, next) => {
  const run = (i) => {
    if (i >= guards.length) return next();
    guards[i](to, from, (arg) => {
      if (arg === undefined || arg === true) return run(i + 1);
      // Se o guard chamou next('/algo') ou next({path}), encerra
      return next(arg);
    });
  };
  run(0);
};

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: isNotAuthenticated
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    beforeEnter: isNotAuthenticated
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: ResetPassword,
    beforeEnter: isNotAuthenticated
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    beforeEnter: isNotAuthenticated
  },
  {
    path: '/desafio-checkout',
    name: 'ChallengeCheckout',
    component: ChallengeCheckout,
  },
  {
    path: '/genialguard-register',
    name: 'GenialGuardRegister',
    component: GenialGuardRegister
  },
  {
    path: '/plans',
    name: 'plans',
    component: Plans,
    props: { source: 'plans' },
    beforeEnter: isNotAuthenticated
  },
  {
    path: '/plans2026',
    name: 'plans2026',
    component: Plans,
    props: { source: 'plans2026' },
    beforeEnter: isNotAuthenticated
  },
  {
    path: '/genialguard-plans',
    name: 'genialguard-plans',
    component: GenialGuardPlans,
    beforeEnter: isNotAuthenticated
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    // Home eh a tela da Calculadora (lista de clientes). Gated por feature.
    beforeEnter: chainGuards(isAuthenticated, hasFeature('calculator')),
    meta: {
      title: 'Calculadora',
      icon: 'fa-user-circle',
    },
  },
  {
    path: '/upgrade',
    name: 'upgrade',
    component: () => import('../views/Upgrade.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      title: 'Atualizar plano',
      icon: 'fa-lock',
    },
  },
  {
    // Consulta Nacional de Regras Previdenciárias.
    // Disponível pra TODOS os planos (decisão 11/06) — autenticação apenas,
    // sem hasFeature. Deep links: ?uf=PR | ?escopo=rgps | &categoria=...
    path: '/consulta-regras',
    name: 'consulta-regras',
    component: () => import('../views/ConsultaRegrasNacionais.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      title: 'Consulta Nacional',
      icon: 'fa-search',
    },
  },
  {
    path: '/bancada',
    name: 'bancada',
    component: BancadaGenIA,
    beforeEnter: chainGuards(isAuthenticated, hasFeature('genias')),
    meta: {
      title: 'Bancada GenIA',
      icon: 'fa-map-signs',
    },
  },
  {
    path: '/online-classes',
    name: 'online-classes',
    component: OnlineClasses,
    beforeEnter: chainGuards(isAuthenticated, hasFeature('courses')),
    meta: {
      title: 'Video Aulas',
      icon: 'fa-question-circle-o',
    },
  },
  {
    path: '/mindmaps',
    name: 'mindmaps',
    component: MindMaps,
    beforeEnter: isAuthenticated,
    meta: {
      title: 'Mapas Mentais',
      icon: 'fa-question-circle-o',
    },
  },
  {
    path: '/customer/:id',
    name: 'customer',
    component: Customer,
    // Bloco do cliente/calculation eh todo gated por 'calculator'.
    beforeEnter: chainGuards(isAuthenticated, hasFeature('calculator')),
    meta: {
      title: 'Cliente',
      icon: 'fa-user-circle',
    },
    children: [
      {
        path: 'calculations/:calculationId',
        name: 'calculations',
        component: Calculations,
        children: [
          {
            path: 'rules',
            name: 'rules',
            component: CustomerRules,
          },
          {
            path: 'rules-not-applicable',
            name: 'rules-not-applicable',
            component: RulesNotApplicable,
          },
          {
            path: 'future-rules',
            name: 'future-rules',
            component: FutureRules,
          },
          {
            path: 'work-records',
            name: 'work-records',
            component: CustomerWorkRecords,
          },
          {
            path: 'genial-report',
            name: 'genial-report',
            component: GenialReport,
          },
        ],
      },
    ],
  },
  {
    path: '/users',
    // name: 'users',
    component: Users,
    meta: {
      title: 'Usuários',
      icon: 'fa-user-circle',
    },
    children: [
      {
        path: '',
        // path: '/',
        name: 'users',
        // name: 'list-users',
        beforeEnter: isManagement,
        component: ListUsers,
      },
      {
        path: ':id/edit',
        name: 'edit-user',
        beforeEnter: isAuthenticated,
        component: UserEdit,
      },
    ],
  },
  {
    path: '/management',
    name: 'management',
    component: Management,
    beforeEnter: isManagement,
    meta: {
      title: 'Gestão',
      icon: 'fa-id-card',
    },
    children: [
      {
        path: 'accounts',
        name: 'accounts',
        component: Accounts,
        meta: {
          title: 'Contas',
        },
      },
      {
        path: 'indexes',
        name: 'indexes',
        component: Indexes,
        meta: {
          title: 'Índices',
        },
      },
      {
        path: 'retirement-factors',
        name: 'retirement-factors',
        component: RetirementFactors,
        meta: {
          title: 'Fator Previdenciário',
        },
      },
      {
        path: 'chat-monitor',
        name: 'chat-monitor',
        component: ChatMonitor,
        meta: {
          title: 'Monitor IA',
        },
      },
      {
        path: 'chat-monitor/:id',
        name: 'conversation-detail',
        component: ConversationDetail,
        meta: {
          title: 'Detalhe da Conversa',
        },
      },
      {
        path: 'agent-configurator',
        name: 'agent-configurator',
        component: AgentConfigurator,
        meta: {
          title: 'Configurador GenIAs',
        },
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
